import type { Optional } from '@festina-life/core'
import { FormikSelect } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import { useTemplatedModelTypes } from '../../uiModels/api/metaModel/useTemplatedModelTypes'
import { validateKey } from './helpers'

type Props = {
  layerId: Optional<string>
  isDisabled: boolean
}

export const TemplateModelTypesInput = ({ layerId, isDisabled }: Props) => {
  const translate = useTranslate()
  const allTemplatedModelTypeNames = useTemplatedModelTypes(layerId)
  return (
    <FormikSelect
      options={allTemplatedModelTypeNames}
      name={validateKey('modelTypeName')}
      label={translate('templateDraftForm.model.label')}
      disabled={isDisabled}
      isRequired
    />
  )
}
